import { useEffect } from "react";
import { connect } from "react-redux";
import "./App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Login/Login";
import { auth } from "./firebase";
import { addUser } from "./redux/actionProvider";

function App({ UserState, AddUserDispatch }) {
  useEffect(() => {
    const listener = auth.onAuthStateChanged((userAuth) => {
      // console.log(userAuth);
      if (userAuth) {
        console.log("UserOnline");
      } else {
        console.log("UserOffline");
      }
      AddUserDispatch(userAuth);
    });
    return () => {
      listener();
    };
    // eslint-disable-next-line
  }, []);

  // console.log(UserState);

  return <div className="App">{UserState ? <Dashboard /> : <Login />}</div>;
}

const mapStateToProp = (state) => {
  return {
    UserState: state.User.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddUserDispatch: (user) => dispatch(addUser(user)),
  };
};

export default connect(mapStateToProp, mapDispatchToProps)(App);
